export default __webpack_public_path__ + "static/media/btn-back.5fac70a9.svg";